module.exports = __webpack_public_path__ + "img/logo.188862d4.png";